import { parseISO } from "date-fns";

export const parseISOFormatDate = (date: string): Date | number => {
  if (date === "" || date === null) {
    return Date.now();
  }

  return parseISO(date);
};
